import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { InputDropdown2 } from '../../../../common/html/input/InputDropdown2'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../helpers/EventEmitter'
import { changePeerOrganizationIds } from '../../store/slice'
import { MAX_SELECTED_COMPANY } from '../constants'
import {
  changeSelectedCompanyList,
  selectSelectedCompanyList,
} from './popupRecommendationList/store/slice'
import { SearchList } from './SearchList'
import { changeSearchData } from './store/slice'

export const SearchInput = () => {
  const dispatch = useDispatch()
  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  const [textSearch, setTextSearch] = useState('')
  const [isShowDropdown, setIsShowDropdown] = useState(false)

  const onChange = (e) => {
    const value = e.target.value
    setTextSearch(value)
  }

  const onClick = (e) => {
    setIsShowDropdown(true)
  }

  const onClickOutsideDropdown = () => {
    setIsShowDropdown(false)
    dispatch(changeSearchData([]))
  }

  const onClickItem = (e) => {
    if (selectedCompanyList.length >= MAX_SELECTED_COMPANY) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [
          <Translate
            value={'companyAnalysis.peerAnalysis.OVER_SELECTION_POPUP_TEXT'}
          />,
        ],
      })
    } else {
      const selectedCompanyListIds = selectedCompanyList.map((item) => item.id)
      dispatch(
        changeSelectedCompanyList([
          ...selectedCompanyList,
          { id: e.organizationId, name: e.organizationName },
        ]),
      )
      dispatch(
        changePeerOrganizationIds([
          ...selectedCompanyListIds,
          e.organizationId,
        ]),
      )
    }
    setIsShowDropdown(false)
  }

  return (
    <InputDropdown2
      placeHolder="companyAnalysis.peerAnalysis.SEARCH_PLACEHOLDER"
      type="text"
      style={{ minWidth: 400 }}
      containerStyle={{
        maxWidth: 390,
        marginRight: 8,
      }}
      isShowDropdown={isShowDropdown && !!textSearch.length}
      onClickOutsideDropdown={onClickOutsideDropdown}
      onClick={onClick}
      onChange={onChange}
    >
      <SearchList textSearch={textSearch} onClickItem={onClickItem} />
    </InputDropdown2>
  )
}
